import { SET_PREVIEW, RESET_PREVIEW } from './actionTypes';

const initialState = {
  columns: [],
};

const preview = (state = initialState, action) => {
  switch (action.type) {
    case SET_PREVIEW:
      return {
        ...state,
        columns: _.cloneDeep(action.payload.columns),
      };

    case RESET_PREVIEW:
      return initialState;

    default:
      return state;
  }
};

export default preview;



// WEBPACK FOOTER //
// ./src/views/ReportPreview/flow/reducer.js